import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title: "TMS for Paramedics | Neuro Wellness TMS Centers of America",
  description:
    "Paramedics: learn about TMS therapy, SAINT TMS, and mental health treatment options for depression, anxiety, and PTSD in Coral Springs, FL.",
  canonical: "/tms-for-paramedics",
  keywords:
    "TMS for paramedics, paramedic depression treatment, paramedic mental health Florida, paramedic PTSD treatment",
};

const relatedLinks = [
  { title: "TMS for First Responders", href: "/tms-for-first-responders" },
  { title: "TMS for EMS", href: "/tms-for-ems" },
  {
    title: "Depression Treatment for First Responders",
    href: "/depression-treatment-for-first-responders",
  },
  {
    title: "First Responder Insurance Verification",
    href: "/first-responder-insurance-verification",
  },
];

export default function TmsForParamedics() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="Paramedics"
      title="TMS for Paramedics"
      subtitle="Paramedics carry the weight of life-and-death decisions on every shift. If medication hasn't helped, there are other treatment options."
    >
      <DecisionSection heading="What paramedics experience">
        <p>
          Paramedics make rapid, high-stakes decisions in chaotic situations,
          often while managing patients in extreme distress. The cumulative
          exposure to trauma, cardiac arrests, accidents, and loss builds over
          years. Depression, anxiety, and PTSD are more common in paramedics
          than in the general population.
        </p>
      </DecisionSection>

      <DecisionSection heading="Treatment options">
        <DecisionList
          items={[
            "TMS — FDA-cleared, non-invasive, outpatient",
            "SAINT accelerated TMS — five-day protocol, FDA-cleared",
            "SPRAVATO (esketamine) — FDA-approved for treatment-resistant depression",
            "Prism for PTSD — EEG neurofeedback for PTSD symptoms",
            "IV ketamine and KAP",
            "Trauma-informed psychotherapy",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="Confidentiality and insurance">
        <p>
          Your treatment is confidential. We do not contact your employer
          without your consent. Our team verifies your insurance benefits and
          handles authorization.
        </p>
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or{" "}
          <Link
            to="/first-responder-insurance-verification"
            className="text-accent hover:underline"
          >
            verify your insurance
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
